module.exports = __webpack_public_path__ + "static/media/summit-centrosul-logo.c5292e51.svg";